import { render, staticRenderFns } from "./OutputSearchStrings.vue?vue&type=template&id=56fe2f8a&scoped=true"
import script from "./OutputSearchStrings.vue?vue&type=script&lang=js"
export * from "./OutputSearchStrings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe2f8a",
  null
  
)

export default component.exports